import { render } from "./EditFacture.vue?vue&type=template&id=53910264&ts=true"
import script from "./EditFacture.vue?vue&type=script&lang=ts"
export * from "./EditFacture.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__